import React, { useContext } from 'react';
import ExternalServicesContext from 'contexts/external_services/context';

export const useExternalServices = () => {
  return useContext(ExternalServicesContext);
};
